import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./AccountStatementPage.module.scss";
import MacbookButton from "../../components/common/macbookButton/MacbookButton";
import {
  FileText,
  DollarSign,
  Shield,
  Clipboard,
  Briefcase,
} from "react-feather";
import BottomNavigationButton from "../../components/common/bottomNavigationButton/BottomNavigationButton";

const AccountStatementPage: React.FC = () => {
  const navigate = useNavigate();

  const handleReceiveReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "receiveReceipt" },
    });
  };

  const handleCommissionReceiveReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "receiveCommissionReceipt" },
    });
  };

  const handleInsuranceReceiveReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "receiveInsuranceReceipt" },
    });
  };

  const handleRentalReceiveReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "receiveRentalReceipt" },
    });
  };

  const handleSpendReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "spendReceipt" },
    });
  };

  const handleCommissionSpendReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "spendCommissionReceipt" },
    });
  };

  const handleInsuranceSpendReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "spendInsuranceReceipt" },
    });
  };

  const handleRentalSpendReceipt = () => {
    navigate("/account-statement-result", {
      state: { accountStatementStatus: "spendRentalReceipt" },
    });
  };

  const isSmallScreen = window.innerWidth <= 1370 && window.innerHeight <= 1030;

  return (
    <>
      <div className={styles["center-container"]}>
        <div className={styles["grid-container"]}>
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleReceiveReceipt}
            buttonText="Receive Receipt"
            icon={<FileText size={20} />}
          />
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleCommissionReceiveReceipt}
            buttonText="Commission Receive Receipt"
            icon={<Clipboard size={20} />}
          />
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleInsuranceReceiveReceipt}
            buttonText="Insurance Receive Receipt"
            icon={<FileText size={20} />}
          />
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleRentalReceiveReceipt}
            buttonText="Rental Receive Receipt"
            icon={<Briefcase size={20} />}
          />
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleSpendReceipt}
            buttonText="Spend Receipt"
            icon={<DollarSign size={20} />}
          />
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleCommissionSpendReceipt}
            buttonText="Commission Spend Receipt"
            icon={<Shield size={20} />}
          />
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleInsuranceSpendReceipt}
            buttonText="Insurance Spend Receipt"
            icon={<Shield size={20} />}
          />
          <MacbookButton
            width={isSmallScreen ? "13rem" : undefined}
            fontSize={isSmallScreen ? "12.9px" : undefined}
            onClick={handleRentalSpendReceipt}
            buttonText="Rental Spend Receipt"
            icon={<Briefcase size={20} />}
          />
        </div>
      </div>
      <div className="flex justify-center">
        <BottomNavigationButton content="Main Menu" to="/main" />
        <BottomNavigationButton content="Finance" to="/finance" />
        <BottomNavigationButton
          content="Account Statement"
          to="/account-statement"
        />
      </div>
    </>
  );
};

export default AccountStatementPage;
